import type { Entity } from '@backstage/catalog-model';
import { RELATION_PART_OF, parseEntityRef } from '@backstage/catalog-model';
import { EntityRefLink, useEntity } from '@backstage/plugin-catalog-react';
import { isPluginAiResourceEntity } from '@backstage/catalog-model/alpha';

import { InstallCard } from './InstallCard';

/** The `partOf` relation target ref pointing at a plugin's parent marketplace. */
const getParentMarketplaceRef = (entity: Entity): string | undefined =>
  entity.relations?.find(
    relation =>
      relation.type === RELATION_PART_OF &&
      parseEntityRef(relation.targetRef).kind === 'airesource',
  )?.targetRef;

export const PluginInstallCard = () => {
  const { entity } = useEntity();

  if (!isPluginAiResourceEntity(entity)) {
    return null;
  }

  const marketplaceRef = getParentMarketplaceRef(entity);
  const marketplaceName = marketplaceRef ? parseEntityRef(marketplaceRef).name : 'MARKETPLACE-NAME';

  return (
    <InstallCard
      warning="Make sure you trust the owner of this plugin and that you know what you are installing."
      requires={
        marketplaceRef ? <EntityRefLink entityRef={marketplaceRef} hideIcon /> : marketplaceName
      }
      command={`copilot plugin install ${entity.metadata.name}@${marketplaceName}`}
    />
  );
};
